var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { id: _vm.modalId, "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xs", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _c("i", { staticClass: "glyphicon glyphicon-calendar" }),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("kanbanImportExport") + ": " + _vm.flow.name
                      ) +
                      " "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-toggle": "modal",
                    "data-target": "#" + _vm.modalId
                  },
                  on: { click: _vm.onClose }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                { staticClass: "btn-toolbar mb-2", attrs: { role: "toolbar" } },
                [
                  _c(
                    "div",
                    { staticClass: "btn-group", attrs: { role: "group" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          class: [
                            _vm.tab === "importFlow"
                              ? "btn-primary"
                              : "btn-secondary"
                          ],
                          attrs: { "data-v-step": "boardoptions" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.tab = "importFlow"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("kanbanImport")) +
                              "\n                        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          class: [
                            _vm.tab === "exportFlow"
                              ? "btn-primary"
                              : "btn-secondary"
                          ],
                          attrs: { "data-v-step": "boardoptions" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.tab = "exportFlow"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("kanbanExport")) +
                              "\n                        "
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "importFlow",
                      expression: "tab === 'importFlow'"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "my-4" }),
                  _vm._v(" "),
                  _c("drop-zone", {
                    attrs: { formId: "dz_equipment" + _vm._uid, url: _vm.url },
                    on: { uploaded: _vm.onImported }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "exportFlow",
                      expression: "tab === 'exportFlow'"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "my-4" }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.exportFlow.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("kanbanExport")))]
                  )
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }